import { Tag } from 'antd';
// helpers
import isEmpty from 'lodash/isEmpty'

const RolesCell: React.FC = (roles: string[] | null) => {

  if (isEmpty(roles)) return null

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        <Tag color="default">{roles[0]}</Tag>
        {roles.length > 1 && <Tag color="default">+{roles.length - 1}</Tag>}
      </div>
    </div>
  )
}

export default RolesCell
